import { render, staticRenderFns } from "./CommonRandomText.vue?vue&type=template&id=4afb52f7&scoped=true"
import script from "./CommonRandomText.vue?vue&type=script&lang=js"
export * from "./CommonRandomText.vue?vue&type=script&lang=js"
import style0 from "./CommonRandomText.vue?vue&type=style&index=0&id=4afb52f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb52f7",
  null
  
)

export default component.exports